function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_13",
  "data-name": "Group 13",
  transform: "translate(-895.333 -1241.344)"
}, React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M-526.483,740.675a3.726,3.726,0,0,1-3.726-3.728q.009-11.888.017-23.774V711.8h4.058a3.725,3.725,0,0,1,3.726,3.725V729.1a3.725,3.725,0,0,0,3.725,3.726h35.471a3.726,3.726,0,0,0,3.725-3.726V661.016a3.726,3.726,0,0,0-3.725-3.726h-35.446a3.726,3.726,0,0,0-3.726,3.726V676.64a3.725,3.725,0,0,1-3.725,3.726h-.3a3.726,3.726,0,0,1-3.726-3.726V652.959a3.725,3.725,0,0,1,3.726-3.725h50.644a3.726,3.726,0,0,1,3.726,3.725v83.99a3.726,3.726,0,0,1-3.726,3.726Z",
  transform: "translate(1462.5 592.11)"
}), React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M-518.873,698.69c-3.906,0-15.292.018-17.211-.01a.832.832,0,0,0-.941.635,15.283,15.283,0,0,1-12.389,10.219A15.573,15.573,0,0,1-567.008,696.6a15.492,15.492,0,0,1,12.661-17.712,15.513,15.513,0,0,1,16.821,8.92,1.179,1.179,0,0,0,1.282.853q21.132-.033,42.265-.015c1.9,0,2.564.668,2.569,2.564q.008,2.462,0,4.923c0,1.931-.624,2.548-2.562,2.564-.275,0-.549,0-.928,0-.021.375-.054.7-.054,1.026-.005,2.508,0,5.016-.005,7.524-.007,1.756-.671,2.423-2.409,2.431q-2.739.012-5.48-.005a1.92,1.92,0,0,1-2.171-2.175c-.02-2.539-.006-8.344-.006-8.756h-3.8c0,.592.009,6.456-.005,8.84a1.887,1.887,0,0,1-2.064,2.088q-2.927.03-5.852,0a1.914,1.914,0,0,1-2.122-2.133C-518.882,704.629-518.873,701.723-518.873,698.69Zm-32.838,2.251a6.736,6.736,0,0,0,6.823-6.626,6.793,6.793,0,0,0-6.733-6.937,6.828,6.828,0,0,0-6.835,6.754A6.763,6.763,0,0,0-551.711,700.941Z",
  transform: "translate(1462.5 592.11)"
}));

var SvgSignin = function SvgSignin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 95.129,
    height: 91.441,
    viewBox: "0 0 95.129 91.441",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSignin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signin.0f75072b.svg";
export { ForwardRef as ReactComponent };